module.exports = __webpack_public_path__ + "img/laptop.4c0071af.svg";